var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import NextLink from 'next/link';
import { Link as ReactLink, LinkPropTypes, } from '@sitecore-jss/sitecore-jss-react';
/**
 * Matches relative URLs that end with a file extension.
 */
const FILE_EXTENSION_MATCHER = /^\/.*\.\w+$/;
export const Link = forwardRef((props, ref) => {
    const { field, editable = true, children, internalLinkMatcher = /^\//g, showLinkTextWithChildrenPresent } = props, htmlLinkProps = __rest(props, ["field", "editable", "children", "internalLinkMatcher", "showLinkTextWithChildrenPresent"]);
    if (!field ||
        (!field.editable &&
            !field.value &&
            !field.href &&
            !field.metadata)) {
        return null;
    }
    const value = (field.href
        ? field
        : field.value);
    // fallback to {} if value is undefined; could happen if field is LinkFieldValue, href is empty in metadata mode
    const { href, querystring, anchor } = value || {};
    const isEditing = editable && (field.editable || field.metadata);
    if (href && !isEditing) {
        const text = showLinkTextWithChildrenPresent || !children ? value.text || value.href : null;
        const isMatching = internalLinkMatcher.test(href);
        const isFileUrl = FILE_EXTENSION_MATCHER.test(href);
        // determine if a link is a route or not. File extensions are not routes and should not be pre-fetched.
        if (isMatching && !isFileUrl) {
            return (React.createElement(NextLink, Object.assign({ href: { pathname: href, query: querystring, hash: anchor }, key: "link", locale: false, title: value.title, target: value.target, className: value.class, prefetch: props.prefetch }, htmlLinkProps, { ref: ref }),
                text,
                children));
        }
    }
    // prevent passing internalLinkMatcher or prefetch as it is an invalid DOM element prop
    const reactLinkProps = Object.assign({}, props);
    delete reactLinkProps.internalLinkMatcher;
    delete reactLinkProps.prefetch;
    return React.createElement(ReactLink, Object.assign({}, reactLinkProps, { ref: ref }));
});
Link.displayName = 'NextLink';
Link.propTypes = Object.assign({ internalLinkMatcher: PropTypes.instanceOf(RegExp) }, LinkPropTypes);
